// extracted by mini-css-extract-plugin
module.exports = {"button":"EllipsisShadowButton_button__oc1OL"};